import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import { Asterisk, Calendar, TextLeft, TextParagraph } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function SpaceInfos({codespace}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [lib, setLib] = useState("");
    const [ident, setIdent] = useState("");
    const [desc, setDesc] = useState("");
    const [etat, setEtat] = useState("");
    const [datecrea, setDatecrea] = useState("");
    const [dateupda, setDateupda] = useState("");
    const [edit, setedit] = useState(true);
    const [defaut, setdefaut] = useState(false);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showWarningMessage = (msg) => {
        toast.warning(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccessMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }


    const getSpace = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/workspaces/${codespace}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setLib(body?.lib !== null ? body?.lib : "");
                        // setIdent(body?.ident !== null ? body?.ident : "");
                        setDesc(body?.descr !== null ? body?.descr : "");
                        setEtat(body?.etat !== null ? body?.etat : "");
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDateupda(body?.dateupda !== null ? body?.dateupda.slice(0, 10) : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                console.log("response", response);
                setError(true);
                setLoading(false);
            }
            
        }).catch((err) => {
            console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const handleedit = () => {
        setedit(!edit);
    };

    const handledefaut = () => {
        setdefaut(!defaut);
    };


    // comportements
    useEffect(() => {
        getSpace();
    }, [])

    const handleDelete = async () => {
        confirmAlert({
            title: 'Supprimer?',
            message: 'Etes-vous sûr de vouloir supprimer cet espace de travail?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/workspaces/${codespace}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccessMessage(textes.fr.oparationsuccess);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete droit", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setDeleting(false);
                            }
                            
                        })
                        .catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setDeleting(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Mise à jour?',
            message: 'Etes-vous sûr de vouloir mettre à jour cet espace de travail?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);
                        
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("lib", lib);
                        // urlencoded.append("ident", ident);
                        urlencoded.append("descr", desc);
                        urlencoded.append("defaut", defaut);
                        urlencoded.append("edit", edit);

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/workspaces/${codespace}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccessMessage(textes.fr.oparationsuccess);
                                setEditedstate(false);
                                getSpace();
                                setFetching(false);

                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }
                            
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row"> 
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    {!editedstate && <button onClick={() => setEditedstate(true)}
                                        title="Modifier l'espace de travail" 
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Modifier</span>
                                    </button>}
                                    {!editedstate && <button onClick={handleDelete}
                                        title="Supprimer l'espace de travail" 
                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-trash mr-1"></i> <span>Supprimer</span>  {deleting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                        />}
                                    </button>}
                                    <h6 className="m-0 ">Informations de l'espace de travail</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{width: "100%"}} onSubmit={handleSubmitEdit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="lib" className="mb-1">Libelle</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="lib">
                                                                <TextParagraph />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={lib}
                                                                onChange={(e) => setLib(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-6 mb-3">
                                                        <label htmlFor="ident" className="mb-1">Identifiant</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="ident">
                                                                <TextLeft />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={ident}
                                                                onChange={(e) => setIdent(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div> */}
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="etat" className="mb-1">Etat de l'espace de travail</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className={`input-group-text ${
                                                                    etat === 1 ? "bg-warning" :
                                                                    etat ===2 ? "bg-success" :
                                                                    ""
                                                                }`
                                                            } 
                                                                id="etat"
                                                            >
                                                                <Asterisk />
                                                            </span>
                                                            <input
                                                                readOnly
                                                                type="text" 
                                                                className={`form-control ${
                                                                        etat === 1 ? "text-white bg-warning" :
                                                                        etat ===2 ? "text-white bg-success" :
                                                                        ""
                                                                    } 
                                                                `} 
                                                                id="etat"
                                                                value={
                                                                    etat === 1 ? "Espace de travail non utilisé" :
                                                                    etat ===2 ? "Espace de travail utilisé" :
                                                                    ""
                                                                }
                                                                placeholder=""
                                                                onChange={(e) => setEtat(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="desc" className="mb-1">Description de l'espace de travail</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="desc">
                                                                <TextParagraph />
                                                            </span>
                                                            <textarea 
                                                                className="form-control" 
                                                                placeholder="Aucune description"
                                                                value={desc}
                                                                style={{height: 154}}
                                                                onChange={(e) => setDesc(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-check">
                                                            <input type="checkbox" id="defaut"
                                                                className="form-check-input"
                                                                checked={defaut}
                                                                onChange={handledefaut}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                            <label htmlFor="defaut" className="mb-1 form-check-label">Par défaut</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-check">
                                                            <input type="checkbox" id="edit"
                                                                className="form-check-input"
                                                                checked={edit}
                                                                onChange={handleedit}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                            <label htmlFor="edit" className="mb-1 form-check-label">Modifiable</label>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="datecrea" className="mb-1">Date de créaation</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="datecrea">
                                                                <Calendar />
                                                            </span>
                                                            <input type={editedstate ? "date" : "text"} 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={datecrea}
                                                                onChange={(e) => setDatecrea(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="dateupda" className="mb-1">Date de dernière mise à jour</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="dateupda">
                                                                <Calendar />
                                                            </span>
                                                            <input type={editedstate ? "date" : "text"} 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={dateupda}
                                                                onChange={(e) => setDateupda(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            {editedstate && <div className="col-md-12 mt-2">
                                                <button type="submit" 
                                                    title="Mise à jour du droit" 
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    // disabled={names && statusinput["value"] ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i> 
                                                    <span>Modifier</span> {fetching && <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                    />}
                                                </button>
                                                <button onClick={() => setEditedstate(false)} 
                                                    title="Annuler l'operation"
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>Annuler</span>
                                                </button>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>}
        </>
    )
}